import { render, staticRenderFns } from "./ListDisbursementConfigs.vue?vue&type=template&id=b128bdbc&scoped=true"
import script from "./ListDisbursementConfigs.vue?vue&type=script&lang=js"
export * from "./ListDisbursementConfigs.vue?vue&type=script&lang=js"
import style0 from "./ListDisbursementConfigs.vue?vue&type=style&index=0&id=b128bdbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b128bdbc",
  null
  
)

export default component.exports